import { Facebook, Instagram, Phone } from "lucide-react";

export const PHONE = "508-594-9882";
export const PHONE_HREF = "tel:+15085949882";
export const EMAIL = "gonetodayjunkremovalma@gmail.com";
export const INSTAGRAM = "https://www.instagram.com/gonetodayjunkremovalma";
export const FACEBOOK = "https://www.facebook.com/profile.php?id=61590789835546";
export const GOOGLE = "https://share.google/nTNfEz2ApCnxFMDQE";

export default function Nav() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-navy/95 backdrop-blur-sm border-b border-white/15">
      <div className="flex items-stretch justify-between">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center gap-3 px-5 py-3 sm:px-8">
          <span
            data-testid="nav-logo-mark"
            className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-full border-2 border-royal bg-white"
          >
            <img src="/logo.png" alt="Gone Today Junk Removal logo" className="h-full w-full scale-110 object-cover" />
          </span>
          <span className="leading-none">
            <span className="block font-display text-lg tracking-wide text-white">GONE TODAY</span>
            <span className="block font-mono2 text-[10px] uppercase tracking-[0.3em] text-white/60">
              Junk Removal
            </span>
          </span>
        </a>
        <div className="hidden items-center gap-6 pr-6 md:flex">
          <span className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-white/60">
            Massachusetts / Rhode Island
          </span>
          <a
            href={INSTAGRAM}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Gone Today Junk Removal on Instagram"
            data-testid="nav-instagram-link"
            className="text-white/70 transition-colors duration-200 hover:text-royal"
          >
            <Instagram className="h-5 w-5" strokeWidth={2} />
          </a>
          <a
            href={FACEBOOK}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Gone Today Junk Removal on Facebook"
            data-testid="nav-facebook-link"
            className="text-white/70 transition-colors duration-200 hover:text-royal"
          >
            <Facebook className="h-5 w-5" strokeWidth={2} />
          </a>
          <a
            href={PHONE_HREF}
            data-testid="nav-call-button"
            className="btn-hard btn-hard-light flex items-center gap-2 bg-royal px-6 py-3 font-display text-base tracking-wide text-white"
          >
            <Phone className="h-4 w-4" strokeWidth={2.5} />
            {PHONE}
          </a>
        </div>
        <div className="flex items-center md:hidden">
          <a
            href={INSTAGRAM}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Gone Today Junk Removal on Instagram"
            data-testid="nav-instagram-link-mobile"
            className="px-3 text-white/80"
          >
            <Instagram className="h-5 w-5" strokeWidth={2} />
          </a>
          <a
            href={FACEBOOK}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Gone Today Junk Removal on Facebook"
            data-testid="nav-facebook-link-mobile"
            className="px-3 text-white/80"
          >
            <Facebook className="h-5 w-5" strokeWidth={2} />
          </a>
          <a
            href={PHONE_HREF}
            data-testid="nav-call-button-mobile"
            className="flex items-center gap-2 self-stretch bg-royal px-5 font-display text-sm text-white"
          >
            <Phone className="h-4 w-4" strokeWidth={2.5} />
            CALL
          </a>
        </div>
      </div>
    </header>
  );
}
